import type { Axios } from 'axios'
import * as Sentry from '@sentry/vue'

export const activateSentryRequest = (axios: Axios) => {
  axios.interceptors.request.use(
    (config) => {
      Sentry.addBreadcrumb({
        category: 'http',
        message: `Request: ${config!.method!.toUpperCase()} ${config.url}`,
        level: 'info',
        data: {
          headers: config.headers,
          body: config.data
        }
      })
      return config
    },
    (error) => {
      Sentry.captureException(error)
      return Promise.reject(error)
    }
  )
}

export const activateSentryResponse = (axios: Axios) => {
  axios.interceptors.response.use(
    (response) => {
      Sentry.addBreadcrumb({
        category: 'http',
        message: `Response: ${response?.status} from ${response?.config?.url}`,
        level: 'info',
        data: {
          headers: response?.headers,
          body: response?.data
        }
      })
      return response
    },
    (error) => {
      Sentry.captureException(error)
      return Promise.reject(error)
    }
  )
}
